module.exports = __webpack_public_path__ + "img/preview.d87a0d29.png";